import { render, staticRenderFns } from "./Approver.vue?vue&type=template&id=7e99f920&scoped=true"
import script from "./Approver.vue?vue&type=script&lang=js"
export * from "./Approver.vue?vue&type=script&lang=js"
import style0 from "./Approver.vue?vue&type=style&index=0&id=7e99f920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e99f920",
  null
  
)

export default component.exports